<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="md"></Loader>
    </b-col>
    <b-col v-else>
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>-->
          <!--<div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>-->
          <!--<div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>-->
          <!--<div v-if="error" class="alert alert-danger" role="alert">-->
            <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
          <!--</div>-->
          <!--<div v-if="deleteError" class="alert alert-danger" role="alert">-->
            <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}-->
          <!--</div>-->
        <!--</b-col>-->
      <!--</b-row>-->
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<router-link v-if="item" :to="{ name: 'EXCMAgreementList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>-->
        <!--</b-col>-->
      <!--</b-row>-->
      <b-row>
        <b-col>
          <EXCMAgreementForm
                  v-if="item"
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations"
                  :initial-values="retrieved" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMAgreementForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMAgreementForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      action: null,
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmagreement/update/isLoading',
      error: 'excmagreement/update/error',
      deleteError: 'excmagreement/del/error',
      deleteLoading: 'excmagreement/del/isLoading',
      created: 'excmagreement/create/created',
      deleted: 'excmagreement/del/deleted',
      retrieved: 'excmagreement/update/retrieved',
      updated: 'excmagreement/update/updated',
      violations: 'excmagreement/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }
      this.$router.push({ name: 'EXCMAgreementList' })
    },
    updated: function (updated) {
      if (this.routeName === 'EXCMAgreementShow') {
        this.$Swal({
          title: updated.agreementNumber + ' ' + this.$t('notifications.updated'),
          type: 'success'
        })
        this.$store.state.modals.excmagreement.update.updated = 1
        this.$store.state.modals.excmagreement.update.close = 1
      }
    },
    retrieved: function () {
      if (this.retrieved.agreementDevices) {
        for (let i in this.retrieved.agreementDevices) {
          if (this.retrieved.agreementDevices[i] && this.retrieved.agreementDevices[i].device && this.retrieved.agreementDevices[i].device['@id']) {
            this.retrieved.agreementDevices[i].device = this.retrieved.agreementDevices[i].device['@id']
          }
        }
      }
      if (this.retrieved.agreementSlas) {
        for (let i in this.retrieved.agreementSlas) {
          if (this.retrieved.agreementSlas[i] && this.retrieved.agreementSlas[i].sla && this.retrieved.agreementSlas[i].sla['@id']) {
            this.retrieved.agreementSlas[i].sla = this.retrieved.agreementSlas[i].sla['@id']
          }
        }
      }
      if (this.retrieved.agreementConsents) {
        for (let i in this.retrieved.agreementConsents) {
          if (this.retrieved.agreementConsents[i] && this.retrieved.agreementConsents[i].consent && this.retrieved.agreementConsents[i].consent['@id']) {
            this.retrieved.agreementConsents[i].consent = this.retrieved.agreementConsents[i].consent['@id']
          }
        }
      }
    }
  },

  beforeCreate () {
    checkPagePermission('agreements', 'EXCMAgreementUpdate')
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmagreement/create/reset',
      deleteItem: 'excmagreement/del/del',
      delReset: 'excmagreement/del/reset',
      retrieve: 'excmagreement/update/retrieve',
      updateReset: 'excmagreement/update/reset',
      update: 'excmagreement/update/update',
      updateRetrieved: 'excmagreement/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmagreement ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm (item) {
      if (item.dateFrom === '') {
        item.dateFrom = undefined
      } else {
        item.dateFrom = this.$moment(item.dateFrom).format('YYYY-MM-DD')
      }
      if (item.dateTo === '') {
        item.dateTo = undefined
      } else {
        item.dateTo = this.$moment(item.dateTo).format('YYYY-MM-DD')
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
